const formattedBirthDate = (birthDate) => {
  const splitDate = birthDate.split('/')
  const date = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`
  return date
}

export default formattedBirthDate;